module.exports = __webpack_public_path__ + "static/contact-6ad648c108eec7fb7ba4fee0e84f3056.jpeg";